<!--
	@component
	Numeric badge displaying a count with an optional prefix string.
	Circle variant fixes width = height = size; pill variant fixes only height and grows horizontally.
	Active state uses the provided colors; inactive state renders in a muted blueish-grey.
-->
<script lang="ts">
	interface Props {
		count: number
		prefix?: string
		color?: string
		backgroundColor?: string
		variant?: 'circle' | 'pill'
		active: boolean
		size?: number
	}

	let {
		count,
		prefix,
		color = 'white',
		backgroundColor = 'var(--color-green-500)',
		variant = 'circle',
		active,
		size = 20
	}: Props = $props()
</script>

<div
	class="counter-badge"
	class:circle={variant === 'circle'}
	class:pill={variant === 'pill'}
	class:active
	style:--cb-size="{size}px"
	style:--cb-font-size="{Math.round(size * 0.6)}px"
	style:--cb-bg={active ? backgroundColor : 'var(--color-blueish-200)'}
	style:--cb-color={active ? color : 'var(--color-blueish-600)'}
>
	{prefix ?? ''}{count}
</div>

<style lang="scss">
	.counter-badge {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		background-color: var(--cb-bg);
		color: var(--cb-color);
		font-size: var(--cb-font-size);
		font-weight: 600;
		line-height: 1;
		height: var(--cb-size);
		min-width: var(--cb-size);
		flex-shrink: 0;
		user-select: none;
		white-space: nowrap;

		&.circle {
			width: var(--cb-size);
			border-radius: 50%;
			aspect-ratio: 1/1;
		}

		&.pill {
			border-radius: calc(var(--cb-size) / 2);
			padding: 0 calc(var(--cb-size) * 0.35);
		}
	}
</style>
